import { useQueryClient } from '@tanstack/react-query';
import { useApiMutation } from '@/hooks/useApiMutation';
import { apiPatch, operationsClient } from '@/lib/api/client';
import { reviewPlatformsV2Endpoints } from '@/lib/api/endpoints';
import { reviewPlatformKeys } from '@/lib/queryKeys';
import type { ReorderPlatformsDto } from '@/types/review-platform';

/**
 * Reorder connected platforms by priority. Sends the full ordered list of
 * PlatformConfig IDs.
 * PATCH /v2/review-platforms/settings/reorder
 */
export function useReorderPlatforms(locationId: string | null = null) {
  const queryClient = useQueryClient();
  return useApiMutation<unknown, ReorderPlatformsDto>({
    mutationFn: (dto) =>
      apiPatch<unknown, ReorderPlatformsDto>(
        operationsClient,
        reviewPlatformsV2Endpoints.reorder(),
        dto,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: reviewPlatformKeys.settings(locationId),
      });
    },
  });
}
